import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SignInService } from '@services/sign-in.service';

import { WINDOW } from '@ng-web-apis/common';
import { LiteratureDocumentListingData } from '@types';

import {
  DocumentsConfig,
  DocumentEntity,
  HeaderDocumentsService,
} from '../services/header-documents.service';
import { AnalyticsService, ComponentTheme } from '@frk/eds-components';
import { extractFileInfoFromLink } from '@utils/link-utils';
import { AppStateService } from '@services';

@Component({
  selector: 'ft-header-documents',
  templateUrl: './header-documents.component.html',
})
export class HeaderDocumentsComponent implements OnInit, OnDestroy {
  public documents: DocumentEntity[];
  public documentsLink: string;
  private previewConfig: DocumentsConfig;
  public literatureDocuments: LiteratureDocumentListingData[];
  private unsubscribe$: Subject<void> = new Subject<void>();
  public componentTheme: ComponentTheme;

  constructor(
    private headerDocumentsService: HeaderDocumentsService,
    private signInService: SignInService,
    private analytics: AnalyticsService,
    private appStateService: AppStateService,
    @Inject(WINDOW) readonly windowRef: Window
  ) {}

  documentClicked(document: DocumentEntity) {
    if (document.protected) {
      this.signInService.setAuth0SignInTitle('signin.sign-in-document-title');
      this.signInService.showSignInModal();
    }
    const linkUrl = this.previewConfig.includes(document.docType)
      ? document.previewLink
      : document.href;
    const {
      fileName,
      fileExtension,
    }: { fileName: string; fileExtension: string } = extractFileInfoFromLink(
      linkUrl
    );
    this.analytics.trackEvent({
      event: 'file_download',
      detailed_event: 'Download Link Clicked',
      link_text: document.title,
      file_name: fileName,
      link_url: linkUrl,
      event_data: {
        file_extension: fileExtension,
        file_lit_code: '',
        file_name: fileName,
        link_url: linkUrl,
        location: '',
      },
    });
  }

  ngOnInit(): void {
    this.documents = [];
    this.componentTheme = this.appStateService.getFundHeaderTheme();

    // TODO fix link to tabs
    this.documentsLink = this.windowRef.location.pathname + '#documents';

    // important - this will be resolved after documents section (literature-fund-document.component) is loaded
    this.headerDocumentsService.documentListingData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((documents: DocumentEntity[]) => {
        this.documents = documents;
      });

    this.headerDocumentsService.previewConfig$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((previewConfig: DocumentsConfig) => {
        this.previewConfig = previewConfig;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
